import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Box } from '@mui/material';
import StepMui from '@mui/material/Step';
import StepperMui from '@mui/material/Stepper';
import StepLabelMui from '@mui/material/StepLabel';
import ContainerMui from '@mui/material/Container';

type ParamsStyle = {
    theme?: Theme;
}

export const Container = styled.div(
    ({ theme }: ParamsStyle) => `
   width: 100%;
   height: 100vh;
   display: flex;

   @media(min-width: ${theme?.breakpoints.values.md}px) {
      
   }
`);

export const ContainerBody = styled.div(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    display: flex;
    margin: 0rem 0 2rem;
    flex-direction: column;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        margin: 0;
        flex-direction: row;
        margin: .75rem 0 2rem;
        justify-content: space-between;
    }
`);

export const ContainerBodyWebView = styled.div(
    ({ theme }: { theme?: Theme }) => `
    width: 100%;
    display: flex;
    height: 100vh;
    overflow: auto;
    padding: 1.25rem 1rem;
    flex-direction: column;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        flex-direction: row;
        justify-content: space-between;
    }
`);

export const ContainerAddService = styled(ContainerMui)(
    ({ theme }: ParamsStyle) => `
        display: flex;
        height: 100%;
        position: relative;
        flex-direction: column;
        margin: 0rem 0 2rem;
        padding: 0;
        justify-content: flex-start;
        
        @media(min-width: ${theme?.breakpoints.values.md}px) {
            flex-direction: row;
            margin: .75rem 0 2rem;
            justify-content: space-between;
        }
`);

export const ContentShopping = styled.div(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    display: flex;
    justify-content: flex-end;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        width: 30%;
        max-width: 20.875rem;
        min-height: calc(100vh - 4rem);
    }
`);

export const ContentBody = styled(Box)(
    ({ theme }: ParamsStyle) => `
    display: flex;
    flex-direction: column;
`);

export const ContentNews = styled.div(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    display: flex;
    justify-content: flex-end;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        width: 30%;
    }
`);

export const BoxBanner = styled(Box)(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    max-width: 100%;
    display: none;
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 1.5rem;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        width: auto;
        display: flex;
        max-width: 14.5rem;
        padding-bottom: 0;
    }
`);

export const Stepper = styled(StepperMui)(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    max-width: 27rem;
    margin-left: -10px;
    align-items: center;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        margin-left: -23px;
    }
`);

export const Step = styled(StepMui)(
    ({ theme }: ParamsStyle) => `
    width: 100%;

    .MuiStepConnector-root.MuiStepConnector-horizontal.MuiStepConnector-alternativeLabel {
        top: 24px;
        z-index: 1;
        left: calc(-50% + 1rem);
        right: calc(50% + 1rem);
    }

    .css-14qqfdt-MuiStepConnector-line {
        border-top-width: 2.5px;
    }

    &.Mui-completed {
        .MuiStepLabel-alternativeLabel {
            .MuiStepLabel-iconContainer {
                border: 2px solid #CBE49E;
            }
        }
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        width: 7.5rem;
    }
`);

export const StepLabel = styled(StepLabelMui)(
    ({ theme }: ParamsStyle) => `
    .MuiStepLabel-labelContainer {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .MuiStepLabel-alternativeLabel {
        color: ${theme?.palette.grey[400]};
        margin-top: 9px !important;
        font-weight: 600;
        z-index: 2;

        &.Mui-completed {
            color: ${theme?.palette.secondary.main};
        }

        &.MuiStepLabel-iconContainer {
            border: 2px solid ${theme?.palette.grey[400]};
            border-radius: 100px;
        }

        &.Mui-active {
            &.MuiStepLabel-label {
                margin-top: 0px !important;
                color: ${theme?.palette.primary.main};;
                padding: 0 3px;
                font-weight: 600;
                border-bottom: 2px solid ${theme?.palette.secondary.main};
            }
        }
    }

    .MuiSvgIcon-root {
        color: ${theme?.palette.grey[400]};
        width: 22px;
        height: 22px;

        text {
            fill: #fff;
        }

        &.Mui-active {
            color: #fff;
            width: 28px;
            height: 28px;
            border-radius: 100px;
            border: 1.6px solid #1C386B;

            .MuiStepIcon-text {
                fill: ${theme?.palette.primary.main};
                color: ${theme?.palette.primary.main};
            }
        }

        &.Mui-completed {
            fill: ${theme?.palette.secondary.main};
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            width: 27px;
            height: 27px;
            
            &.Mui-active {
                width: 34px;
                height: 34px;
            }
        }
    }
               
    .MuiStepIcon-text {
        fill: ${theme?.palette.grey[400]};
        color: ${theme?.palette.grey[400]};
    }

    .css-zpcwqm-MuiStepConnector-root {
        .css-14qqfdt-MuiStepConnector-line {
            border-top-width: 5px;
        }
    }
`);

export const ContentButton = styled('div')(
    ({ theme }: ParamsStyle) => `
        display: flex;
        margin: 1.875rem 0 6.2rem;

        button {
            width: 100%;
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            display: none;
        }
`);

